import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import example from "./example.PNG";

const CardUser = ({ user }) => {

    return (

        <DivRow>
            <ImageProfile src={example} />
            <DivColumn>
                <Text1>
                    ENZO VAZQUEZ
                </Text1>
                <Text2>
                    ASESOR | LA PLATA
                </Text2>
            </DivColumn>
        </DivRow>

    );
};
const DivColumn = styled.div`
width:80%
height:auto;
display:flex;
flex-direction:column;
align-items:flex-start;
`;
const DivRow = styled.div`
gap: 12px;
    width: -webkit-fill-available;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom:8px;
    padding:4px;
    margin-right:8px;
    curosr:pointer;
    &:hover{
        background-color:#f2f2f2;
    }
`;
const ImageProfile = styled.img`
width: 48px;
height:48px;
border-radius:50%;
border:solid 2px #1a455b;
`;

const Text1 = styled.span`
font-size:18px;
font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color:#334443;
`;
const Text2 = styled.span`
font-size:10px;
font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color:#5c6868;
  leter-spacing:3%;
`;
export default CardUser;